// lib/slides/reviewRecall.ts

/**
 * Follow-up turns an agent run may chain before the loop halts it: 30 for a chat; a Slides review walks every page and
 * then ten points, so it gets two more a page (2026-10-19/21: reviews of 14 and 22 pages halted at 32 and 34 turns,
 * one short of its tenth verdict). Stop still ends any run at once.
 */
export const recallLimit = (reviewPageCount: number | null): number => 30 + (reviewPageCount === null ? 0 : 2 * Math.max(0, Math.floor(reviewPageCount)));
